import { Component, OnInit } from '@angular/core';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IIntegrationInput } from 'src/app/shared/interfaces/integration/IIntegrationInput';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { OtrsChildIntegrationComponent } from '../../../modal-templates/integration/otrs-modal/otrs-child-integration/otrs-child-integration.component';
import { OtrsIntegrationsTableComponent } from '../../../modal-templates/integration/otrs-modal/otrs-integrations-table/otrs-integrations-table.component';
import { OtrsParentIntegrationStepOneComponent } from '../../../modal-templates/integration/otrs-modal/otrs-parent-integration-step-one/otrs-parent-integration-step-one.component';
import { OtrsParentIntegrationStepTwoComponent } from '../../../modal-templates/integration/otrs-modal/otrs-parent-integration-step-two/otrs-parent-integration-step-two.component';
import { ButtonColorType } from './../../../../enums/ButtonColorType';
import { IIntegrationApiResponse } from './../../../../interfaces/api/portlets/IIntegrationApiResponse';

@Component({
    selector: 'app-otrs-integration',
    templateUrl: './otrs-integration.component.html',
    styleUrls: ['./otrs-integration.component.sass']
})
export class OtrsIntegrationComponent implements OnInit {
    integrationInput: IIntegrationInput = null;
    widgetRef: Widget;
    isUserIntegrated = false;
    isParentIntegrated = false;
    isOwnerIntegrated = false;
    isConfigured: Boolean = false;
    response: IIntegrationApiResponse;

    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.setUpBasics();
    }

    setUpBasics() {
        this.integrationInput = {
            integrationName: this.widgetRef.widgetData.widgetInfo.text,
            integrationCategory: 'ITSM Integration',
            imageUrl: 'assets/integrations/otrs_2.png',
            buttons: [],
            imagePadding: 8
        };
    }

    generateButtons(response: IIntegrationApiResponse) {
        if (
            this.isOwnerIntegrated ||
            this.isUserIntegrated ||
            this.isParentIntegrated
        ) {
            if (
                !this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                !this.isUserIntegrated
            ) {
                this.isConfigured = true;
                // Adding edit button
                this.integrationInput.buttons.push({
                    buttonName: 'Edit',
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-wrench'
                    },

                    hoverText: 'Edit OTRS',
                    function: () => {
                        this.openParentIntegrationModal(response, 'Edit OTRS');
                    }
                });

                // Adding delete button
                this.integrationInput.buttons.push({
                    buttonName: 'Delete',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-trash'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.WARN,

                    hoverText: 'Remove OTRS',
                    function: (modalId: Symbol) => {
                        // Delete integration
                        const args = Helper.generateHitApiConfig(
                            this.widgetRef.widgetData.widgetInfo.delete
                        );
                        args.input = {
                            parentIntegration: true,
                            childIntegration: false,
                            integrationType: 'OTRS'
                        };
                        args.function = (response) => {
                            this.widgetRef.notificationsService.showSnackBar(
                                `OTRS integration removed successfully`
                            );
                            this.widgetRef.modalService.closeModal(
                                null,
                                modalId
                            );
                            this.widgetRef.refreshWidget();
                        };
                        args.errorFunction = (error) => {
                            Helper.showErrorMessage(
                                this.widgetRef.notificationsService,
                                error,
                                'Error removing OTRS'
                            );
                            this.widgetRef.modalService.closeModal(
                                null,
                                modalId
                            );
                        };
                        new HitApi(
                            args,
                            this.widgetRef.httpService,
                            this.widgetRef.ngZone
                        ).hitApi();
                    },
                    executeFunctionAfterConfirmation: {
                        modalName: 'Remove OTRS Integration',
                        modalIcon: {
                            type: IconType.FONTAWSOME,
                            class: 'far fa-trash-alt'
                        },
                        contextIcon: {
                            extraClass: 'color-accent',
                            type: IconType.FONTAWSOME,
                            class: 'fas fa-exclamation-triangle'
                        },
                        confirmationMessage: `Are you sure you want to remove OTRS ?`,
                        buttonText: 'Remove',
                        buttonColorType: ButtonColorType.WARN,
                        loaderOnExec: true
                    }
                });
            }

            if (
                this.isOwnerIntegrated &&
                !this.isParentIntegrated &&
                !this.isUserIntegrated
            ) {
                this.isConfigured = true;
                // Adding Integrate as Child button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform child-level integration',
                    function: () => {
                        this.openChildIntegrationModal(response);
                    }
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform parent-level integration',
                    function: () => {
                        this.openParentIntegrationModal(response, 'OTRS Setup');
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                !this.isUserIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,

                    hoverText: 'Perform child-level integration',
                    function: () => {
                        this.openChildIntegrationModal(response);
                    }
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },
                    buttonType: 'SUCCESS',
                    buttonClass: 'disabled',
                    disable: true,
                    hoverText: 'Perform parent-level integration',
                    function: () => {}
                });

                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,

                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                !this.isParentIntegrated &&
                this.isUserIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    // buttonType: 'SUCCESS',
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    disable: true,
                    hoverText: 'Perform child-level integration',
                    function: () => {}
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform parent-level integration',
                    function: () => {
                        this.openParentIntegrationModal(response, 'OTRS Setup');
                    }
                });

                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                this.isUserIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    hoverText: 'Perform child-level integration',
                    disable: true,
                    function: () => {}
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    disable: true,
                    hoverText: 'Perform parent-level integration',
                    function: () => {}
                });

                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },

                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
        }
    }
    onIntegrate() {
        this.openParentIntegrationModal(this.response, 'OTRS Setup');
    }
    openParentIntegrationModal(response, modalName: string) {
        const modalArgs: IModalData = {
            modalName: modalName,
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-wrench'
            },
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Credentials',
                    resetModal: true,
                    stepData: {
                        componentToLoad: OtrsParentIntegrationStepOneComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                },
                {
                    stepName: 'Configure Ticket Fields',
                    stepData: {
                        componentToLoad: OtrsParentIntegrationStepTwoComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    },
                    stepHeightVh: 85
                }
            ],
            modalWidthVw: 60,
            modalHeightVh: 80,
            noBottomPadding: true
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    openIntegrationsListingModal(response) {
        const modalArgs: IModalData = {
            modalName: 'Existing Integrations',
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-ticket-alt'
            },
            modalSteps: [
                {
                    stepName: 'Integrations List',
                    stepData: {
                        componentToLoad: OtrsIntegrationsTableComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 60,
            modalHeightVh: 60
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    openChildIntegrationModal(response) {
        const modalArgs: IModalData = {
            modalName: 'OTRS Setup',
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-ticket-alt'
            },
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Credentials',
                    stepData: {
                        componentToLoad: OtrsChildIntegrationComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 60,
            modalHeightVh: 50
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    bindData(response: IIntegrationApiResponse): void {
        this.isConfigured = false;
        this.response = response;
        this.isOwnerIntegrated = response['ownerIntegration'];
        this.isUserIntegrated = response['userIntegration'];
        this.isParentIntegrated = response['parentIntegration'];

        this.integrationInput.buttons = [];
        this.generateButtons(response);
        this.widgetRef.endLoader();
    }

    ngAfterViewInit(): void {
        this.widgetRef.setBindData(this.bindData.bind(this));
    }
}
